import * as loglevel from "loglevel"

export const log = loglevel
log.setDefaultLevel("ERROR")

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const prettyJson = (write: any): string => JSON.stringify(write, null, 2)
